export enum PromotionType {
  HOTEL_DISCOUNT_ACTION = 'HotelDiscountAction',
  STAY_XPAY_YACTION = 'StayXPayYAction',
  TOUR_DISCOUNT_ACTION = 'TourDiscountAction',
  BANK_POS_DISCOUNT_PROMOTION = 'BankPosDiscountPromotion',
  GENERAL_DISCOUNT_PROMOTION = 'GeneralDiscountPromotion',
  PROMO_CODE_PROMOTION = 'PromoCodePromotion',
  HOPI_BOOSTER = 'HopiBooster',
  HOPI_PARACIK = 'HopiParacik',
  SETUR_POINT_USE = 'SeturPointUse',
  HOTEL_RUNNER_DISCOUNT = 'HotelRunnerDiscount',
}
